import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { App } from '@df/core/app';
import { ZippyModule } from '@df/legacy/ui/zippy/zippy.module';
import { ColorOptions, LinksOptions, TextStyleOptions } from '@df/ui/atomic/atomic-options';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { IPageComponentMenuData } from './menu.interface';

let uid = 0;

@Component({
    selector: 'page-component-menu',
    templateUrl: './menu.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [NgClass, ZippyModule, HrefComponent, ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<PageComponentMenuComponent>({
    id: 'menu',
    name: 'Menu',
    description: 'Menu Presentation',
    tags: ['nav', 'menu', 'mobile', 'off-canvas'],
    isAdvanced: true,
    fields: [
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'menu',
            title: 'Menu Items',
            itemName: 'Item',
            itemNameField: 'text',
            defaultSize: 3,
            defaultPart: {
                components: []
            },
            fields: [
                {
                    key: 'text',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Item text',
                    default: 'Some link',
                    required: true
                },
                {
                    key: 'link',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Link'
                },
                <NICmsContentField.IChoiceField>{
                    key: 'link_class',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Link Style',
                    options: LinksOptions,
                    default: LinksOptions[0] ? LinksOptions[0].key : undefined
                },
                <NICmsContentField.IChoiceField>{
                    key: 'color',
                    title: 'Color',
                    type: NICmsContentField.EFieldType.choice,
                    previewMode: 'color',
                    options: ColorOptions,
                    description: 'Text color'
                }
            ]
        },
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-general',
            title: 'General'
        },
        <NICmsContentField.IChoiceField>{
            key: 'color',
            type: NICmsContentField.EFieldType.choice,
            title: 'Text Color',
            description: 'Default text color',
            options: ColorOptions,
            previewMode: 'color',
            default: ''
        },
        <NICmsContentField.IChoiceField>{
            key: 'text_style',
            type: NICmsContentField.EFieldType.choice,
            title: 'Text Style',
            options: TextStyleOptions,
            default: ''
        },
        <NICmsContentField.IChoiceField>{
            key: 'link_class',
            type: NICmsContentField.EFieldType.choice,
            title: 'Default Link Style',
            options: LinksOptions,
            default: LinksOptions[0] ? LinksOptions[0].key : undefined
        }
    ]
})
export class PageComponentMenuComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IPageComponentMenuData;
    protected uid = uid++;

    constructor(private app: App) {
        super();
    }

    override ngOnInit() {
        super.ngOnInit();
        this.subscriptions.add(this.app.meta.subscribe(() => this.detectChanges()));
    }
}
